const validatePage2 = (values) => {
    const errors = {}
    if (!values.conQuienReside) {
        errors.conQuienReside = 'Este campo es requerido, seleccione con quien reside'
    }
    if (values?.conQuienReside?.id === 23) {
        if (!values.otroConQuienReside) {
            errors.otroConQuienReside = 'Este campo es requerido, indique con quien reside'
        }
    }
    if (!values.estrato) {
        errors.estrato = 'Este campo es requerido, seleccione su estrato'
    }
    if (!values.dependeEconómicamente) {
        errors.dependeEconómicamente = 'Este campo es requerido, seleccione si depende económicamente de alguien'
    }
    if (!values.tienePuntajeSisben) {
        errors.tienePuntajeSisben = 'Este campo es requerido, indique puntaje Sisben'
    }
    if (values?.tienePuntajeSisben?.id === 30) {
        if (!values.cualPuntajeSisben) {
            errors.cualPuntajeSisben = 'Este campo es requerido, seleccione su puntaje Sisben'
        }
    }
    if (!values.listadoCensal) {
        errors.listadoCensal = 'Este campo es requerido, seleccione si hace parte de un listado censal'
    }
    if (values?.listadoCensal?.id === 30) {
        if (!values.indiqueListadoCensal) {
            errors.indiqueListadoCensal = "Este campo es requerido, indique cuál listado censal"
        }
    }
    if (values?.indiqueListadoCensal?.id === 116) {
        if (!values.cualListadoCensal) {
            errors.cualListadoCensal = "Este campo es requerido, indique cuál listado censal"
        }
    }
    if (!values.agremiación) {
        errors.agremiación = 'Este campo es requerido, indique si hace parte de alguna asociación que pague su salud'
    }
    if (values?.agremiación?.id === 30) {
        if (!values.tipoAgremiación) {
            errors.tipoAgremiación = 'Este campo es requerido, que tipo de agremiación.'
        }
    }
    if (values?.agremiación?.id === 30) {
        if (values?.tipoAgremiación?.id === 108) {
            if (!values.cualAgremiación) {
                errors.cualAgremiación = 'Este campo es requerido, indique la otra agremiación.'
            }
        }
    }

    if (!values.afiliaciónSalud) {
        errors.afiliaciónSalud = 'Este campo es requerido, indique su forma de afiliación al sistema de salud'
    }
    if (!values.tieneDiscapacidad) {
        errors.tieneDiscapacidad = 'Este campo es requerido, indique si tiene alguna discapacidad'
    }
    if (values?.tieneDiscapacidad?.id === 30) {
        if (!values.cualDiscapacidad) {
            errors.cualDiscapacidad = 'Este campo es requerido, seleccione cuál discapacidad'
        }
    }

    if (values?.tieneDiscapacidad?.id === 30) {
        if (values?.cualDiscapacidad?.id === 461 ) {
            if(!values.cualOtraDiscapacidad){
                errors.cualOtraDiscapacidad = 'Este campo es requerido, describa que otra discapacidad tiene'
            }
        }
    }

    return errors
}

export default validatePage2;